import { render, staticRenderFns } from "./ProductionPayment.vue?vue&type=template&id=1e4c5003&"
import script from "./ProductionPayment.vue?vue&type=script&lang=js&"
export * from "./ProductionPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports